import { SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from '@/components/ui/sidebar';
import { useTranslation } from '@/hooks/useTranslation';
import { ChevronsLeft } from 'lucide-react';
import { useGetCompany } from '@/queries/company.queries';
import { Logo } from '@/components/atoms/Logo';

export const AppSidebarHeader = () => {
  const { t } = useTranslation();
  const { toggleSidebar } = useSidebar();
  const { data: company } = useGetCompany();
  const organizationName = company?.name;

  return (
    <SidebarHeader className="p-4 pr-2 group-data-[collapsible=icon]:p-2">
      <SidebarMenu>
        <SidebarMenuItem className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Logo
              imageVariant="white"
              logoClassName="size-[34px] p-[6px] rounded-full border-sidebar-border bg-black group-data-[collapsible=icon]:hidden"
              showText={false}
            />
            <div className="grid flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden">
              <span className="text-base/5 font-medium">
                {t('general.appName')}
              </span>
              {organizationName && (
                <span className="text-sidebar-foreground text-xxs font-normal truncate" >
                  for {organizationName}
                </span>
              )}
            </div>
          </div>

          <SidebarMenuButton
            className="w-fit items-center justify-center"
            tooltip={t('general.expand')}
            onClick={() => toggleSidebar()}
          >
            <ChevronsLeft className="size-4 shrink-0 transition-transform duration-200 group-data-[collapsible=icon]:rotate-180" />
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarHeader>
  );
};
